import AOS from 'aos';

import moveModals from '../globals/move-modals';
import {floatLabels, errorTabIndex} from '../globals/forms';
import {removeLoadingClassFromLoadedImages, handleImageLoaded} from '../globals/images';
import {setVarsOnResize} from '../globals/height';
import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../util/resize';
import scrollListener from '../util/scroll';
import {CountdownTimer} from '../features/countdown-timer';

resizeListener();
scrollListener();
// Remove "loading-shimmer" class from cached and very fast images
removeLoadingClassFromLoadedImages(document);

// Watch for any load events that bubble up from child elements
document.addEventListener(
  'load',
  (e) => {
    const el = e.target;

    // Capture load events from img tags and then remove their `loading-shimmer` class
    handleImageLoaded(el);
  },
  true
);

// Tasks to run when the DOM elements are available
window.addEventListener('DOMContentLoaded', () => {
  setVarsOnResize();
  floatLabels(document);
  errorTabIndex(document);
  moveModals(document);
  if (window.theme.settings.animate_scroll) {
    AOS.refresh();
  }
});

// Tasks to run when entire page has finished loading including images, stylesheets, async scripts, etc
window.addEventListener('load', () => {
  // Fix any text overflow in position:absolute elements
  preventOverflow(document);
  // Catch any images that loaded before our load event listener above and remove "loading-shimmer" class
  removeLoadingClassFromLoadedImages(document);
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  floatLabels(container);
  errorTabIndex(container);
  moveModals(container);
  preventOverflow(container);
  if (window.theme.settings.animate_scroll) {
    AOS.refresh();
  }
});

document.addEventListener('shopify:section:reorder', () => {
  document.dispatchEvent(new CustomEvent('theme:header:check', {bubbles: false}));
});

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
